import { noop } from 'lodash';
import { createContext, useContext } from 'react';

export type DirtyContextType = {
  isDirty: boolean;
  setDirty: (val: boolean) => void;
};

export const DirtyContext = createContext<DirtyContextType>({
  isDirty: false,
  setDirty: noop,
});

export const useDirtyContext = () => useContext(DirtyContext);
